export default "__VITE_ASSET__BrhuH$9I__"